import React, { useEffect, useState } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { useLocation, Link } from "react-router-dom";
import { toast } from 'react-toastify';

function Header() {
    const { instance } = useMsal();
    const isAuthenticated = useIsAuthenticated();

    const LoginHandler = () => {
        try {
            instance.loginRedirect();
        } catch (err) {
            toast.error("Inloggen mislukt.");
        }
    }

    const LogoutHandler = () => {
        try {
            instance.logout();
        } catch (err) {
            toast.error("Uitloggen mislukt.");
        }
    }

    const HeaderContent = () => {

        return (
            <header className="d-flex flex-wrap justify-content-center py-3 mb-4 border-bottom">
                <a href="/" className="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-dark text-decoration-none ">
                    <i className="bi bi-building fs-4"></i>
                    <span className="fs-4 ms-2">Jeugdlink</span>
                </a>
                <ul className="nav nav-pills">
                    <li className="nav-item">
                        <button className="nav-link"
                            onClick={isAuthenticated ? LogoutHandler : LoginHandler}>
                            {isAuthenticated ? "Uitloggen" : "Inloggen"}
                        </button>
                    </li>
                </ul>
            </header>
        );
    };

    return (
        <div className="container">
            <HeaderContent />
        </div>
    );
}

export default Header;